import React, { useId, useState } from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { DeleteOutline, EditOutlined } from '@mui/icons-material';
import { useLanguage } from '../../contexts/LanguageContext';
import { Debt } from '../../types';
import RowActionsButton from '../common/RowActionsButton';

interface DebtActionsMenuProps {
  debt: Debt;
  onEdit: (debt: Debt) => void;
  onDelete: (debt: Debt) => void;
}

const DebtActionsMenu: React.FC<DebtActionsMenuProps> = ({ debt, onEdit, onDelete }) => {
  const { t } = useLanguage();
  const id = useId();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const close = () => setAnchorEl(null);

  return (
    <>
      <RowActionsButton
        id={`${id}-button`}
        aria-label={`${t('common.actions')}: ${debt.customerName}`}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        aria-controls={anchorEl ? `${id}-menu` : undefined}
        onClick={event => setAnchorEl(event.currentTarget)}
      />
      <Menu
        id={`${id}-menu`}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ list: { 'aria-labelledby': `${id}-button` } }}
      >
        <MenuItem onClick={() => { close(); onEdit(debt); }}>
          <ListItemIcon><EditOutlined fontSize="small" /></ListItemIcon>
          <ListItemText>{t('common.edit')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => { close(); onDelete(debt); }} sx={{ color: 'error.main' }}>
          <ListItemIcon sx={{ color: 'inherit' }}><DeleteOutline fontSize="small" /></ListItemIcon>
          <ListItemText>{t('common.delete')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default DebtActionsMenu;
